/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".link[_ngcontent-%COMP%]{width:100%;text-align:right;cursor:pointer;color:var(--customPrimary)}"];
export { styles as styles };
